"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiSelector = exports.useSelector = void 0;
var tslib_1 = require("tslib");
var downshift_1 = require("downshift");
function useSelector(_a) {
    var items = _a.items, itemToString = _a.itemToString, selectedItem = _a.selectedItem, onSearch = _a.onSearch, getDisabledProps = _a.getDisabledProps, getItemKey = _a.getItemKey, inputRef = _a.inputRef, rest = (0, tslib_1.__rest)(_a, ["items", "itemToString", "selectedItem", "onSearch", "getDisabledProps", "getItemKey", "inputRef"]);
    var selectedItemKey = selectedItem ? getItemKey(selectedItem) : null;
    var _b = (0, downshift_1.useCombobox)((0, tslib_1.__assign)({ items: items, itemToString: itemToString, selectedItem: selectedItem, onInputValueChange: function (changes) { var _a; return onSearch === null || onSearch === void 0 ? void 0 : onSearch((_a = changes.inputValue) !== null && _a !== void 0 ? _a : ''); }, stateReducer: function (state, _a) {
            var type = _a.type, changes = _a.changes;
            var disabled;
            if (defaultReducer[type]) {
                return defaultReducer[type](state, { type: type, changes: changes });
            }
            switch (type) {
                case downshift_1.useCombobox.stateChangeTypes.InputKeyDownEnter:
                case downshift_1.useCombobox.stateChangeTypes.ItemClick:
                    disabled = changes.selectedItem
                        ? getDisabledProps === null || getDisabledProps === void 0 ? void 0 : getDisabledProps(changes.selectedItem, { index: state.highlightedIndex })
                        : undefined;
                    if (disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled) {
                        return state;
                    }
                    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, changes), { inputValue: '' });
                default:
                    return changes;
            }
        }, onIsOpenChange: function (changes) {
            var _a;
            if (changes.isOpen) {
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        } }, rest)), getComboboxProps = _b.getComboboxProps, getMenuProps = _b.getMenuProps, getItemProps = _b.getItemProps, getInputProps = _b.getInputProps, getToggleButtonProps = _b.getToggleButtonProps, isOpen = _b.isOpen, highlightedIndex = _b.highlightedIndex, openMenu = _b.openMenu, closeMenu = _b.closeMenu, inputValue = _b.inputValue, reset = _b.reset;
    return {
        getComboboxProps: getComboboxProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        getMenuProps: getMenuProps,
        getToggleButtonProps: getToggleButtonProps,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        closeMenu: closeMenu,
        openMenu: openMenu,
        inputValue: inputValue,
        clear: reset,
        selectedItem: selectedItem,
        selectedItemKey: selectedItemKey,
    };
}
exports.useSelector = useSelector;
function useMultiSelector(_a) {
    var inputRef = _a.inputRef, items = _a.items, itemToString = _a.itemToString, selectedItemsProp = _a.selectedItems, getDisabledProps = _a.getDisabledProps, onSearch = _a.onSearch, getItemKey = _a.getItemKey, onSelect = _a.onSelect;
    var _b = (0, downshift_1.useMultipleSelection)({
        selectedItems: selectedItemsProp,
        onSelectedItemsChange: function (changes) {
            var _a;
            onSelect((_a = changes.selectedItems) !== null && _a !== void 0 ? _a : []);
        },
        itemToString: itemToString,
    }), getDropdownProps = _b.getDropdownProps, removeSelectedItem = _b.removeSelectedItem, addSelectedItem = _b.addSelectedItem, selectedItems = _b.selectedItems;
    var selectedItemKeys = selectedItems.map(getItemKey);
    var availableItemKeys = items
        .filter(function (item, index) { var _a; return !((_a = getDisabledProps === null || getDisabledProps === void 0 ? void 0 : getDisabledProps(item, { index: index })) === null || _a === void 0 ? void 0 : _a.isDisabled); })
        .map(getItemKey);
    var _c = useSelector({
        items: items,
        itemToString: itemToString,
        selectedItem: null,
        inputRef: inputRef,
        onSearch: onSearch,
        getItemKey: getItemKey,
        onStateChange: function (_a) {
            var selectedItem = _a.selectedItem, type = _a.type;
            switch (type) {
                case downshift_1.useCombobox.stateChangeTypes.InputKeyDownEnter:
                case downshift_1.useCombobox.stateChangeTypes.ItemClick:
                    if (!selectedItem) {
                        return;
                    }
                    if (selectedItemKeys.includes(getItemKey(selectedItem))) {
                        var itemToRemove = selectedItemsProp.find(function (item) { return getItemKey(item) === getItemKey(selectedItem); });
                        removeSelectedItem(itemToRemove);
                    }
                    else {
                        addSelectedItem(selectedItem);
                    }
                    break;
                default:
                    break;
            }
        },
        stateReducer: function (state, _a) {
            var type = _a.type, changes = _a.changes;
            var disabled;
            if (defaultReducer[type]) {
                return defaultReducer[type](state, { type: type, changes: changes });
            }
            switch (type) {
                case downshift_1.useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem:
                    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, changes), { inputValue: state.inputValue });
                case downshift_1.useCombobox.stateChangeTypes.InputKeyDownEnter:
                case downshift_1.useCombobox.stateChangeTypes.ItemClick:
                    disabled = changes.selectedItem
                        ? getDisabledProps === null || getDisabledProps === void 0 ? void 0 : getDisabledProps(changes.selectedItem, { index: state.highlightedIndex })
                        : undefined;
                    if (disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled) {
                        return state;
                    }
                    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, changes), { isOpen: true, highlightedIndex: state.highlightedIndex, inputValue: state.inputValue });
                default:
                    return changes;
            }
        },
    }), getComboboxProps = _c.getComboboxProps, getMenuProps = _c.getMenuProps, getItemProps = _c.getItemProps, getInputProps = _c.getInputProps, getToggleButtonProps = _c.getToggleButtonProps, inputValue = _c.inputValue, isOpen = _c.isOpen, highlightedIndex = _c.highlightedIndex, openMenu = _c.openMenu, closeMenu = _c.closeMenu;
    function handleSelectAll() {
        var availableItems = items.filter(function (item, index) { var _a; return !((_a = getDisabledProps === null || getDisabledProps === void 0 ? void 0 : getDisabledProps(item, { index: index })) === null || _a === void 0 ? void 0 : _a.isDisabled); });
        onSelect(availableItems);
    }
    return {
        getComboboxProps: getComboboxProps,
        getDropdownProps: getDropdownProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        getMenuProps: getMenuProps,
        getToggleButtonProps: getToggleButtonProps,
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        closeMenu: closeMenu,
        openMenu: openMenu,
        isAllSelected: selectedItemKeys.length === availableItemKeys.length,
        clear: function () { return onSelect([]); },
        selectAll: handleSelectAll,
        selectedItemKeys: selectedItemKeys,
        removeSelectedItem: removeSelectedItem,
    };
}
exports.useMultiSelector = useMultiSelector;
var defaultReducer = (_a = {},
    _a[downshift_1.useCombobox.stateChangeTypes.ToggleButtonClick] = function (_state, _a) {
        var changes = _a.changes;
        return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, changes), { inputValue: '' });
    },
    _a[downshift_1.useCombobox.stateChangeTypes.FunctionOpenMenu] = function (_state, _a) {
        var changes = _a.changes;
        return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, changes), { inputValue: '' });
    },
    _a[downshift_1.useCombobox.stateChangeTypes.FunctionReset] = function (_state, _a) {
        var changes = _a.changes;
        return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, changes), { isOpen: false });
    },
    _a);
//# sourceMappingURL=index.js.map